import {
  WSActions,
  WSFlexBox,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";

import { useRef, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  FormBusinessProfile,
  FormBusinessProfileRef
} from "../components/FormBusinessProfile";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const BusinessProfile: React.FC<FlowStep> = ({ title, onSkip }) => {
  const history = useHistory();
  const match = useRouteMatch();
  const [loading, setLoading] = useState<boolean>(false);
  const businessProfileFormRef = useRef<FormBusinessProfileRef>(null);

  return (
    <>
      <WSPanel mb="2XL">
        <WSFlexBox direction="column">
          <WSText.Heading4 weight="medium" color="gray600">
            {title}
          </WSText.Heading4>
          <WSText.ParagraphSm weight="book" color="gray500">
            Complete your business profile with a logo, links, and web presence
            to help contractors identify your business.
          </WSText.ParagraphSm>

          <FormBusinessProfile
            ref={businessProfileFormRef}
            setLoading={setLoading}
            onSuccess={() => {
              history.push(`${match.url}/complete`);
            }}
            my="2XL"
          />
        </WSFlexBox>
      </WSPanel>
      <WSActions
        mb="2XL"
        orientation="vertical"
        buttons={[
          {
            label: "Continue",
            loading,
            onClick: () => {
              businessProfileFormRef.current?.requestSubmit();
            }
          },
          {
            label: "Skip for now",
            kind: "Link",
            onClick: onSkip
          }
        ]}
      />
      <WSText.ParagraphXs weight="book" color="gray400">
        Business profile settings can be viewed and updated at any time in your
        settings.
      </WSText.ParagraphXs>
    </>
  );
};
